import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

if (navigator.userAgent.includes('GPayEmbeddedView')) {
  document.documentElement.classList.add('is-gpay-webview');
  document.body.classList.add('is-gpay-webview');
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
const checkInterval = 1000 * 60;
const updateInterval = setInterval(() => {
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.ready.then((reg) => {
      reg.update();
      clearInterval(updateInterval);
    });
    console.log(
      'New content is available and will be used when all ' +
      'tabs for this page are closed. See https://cra.link/PWA.'
    );
  }
  else {
    // At this point, everything has been precached.
    // It's the perfect time to display a
    // "Content is cached for offline use." message.
    console.log('Content is cached for offline use.');
  }
}, checkInterval);
navigator.serviceWorker.addEventListener("controllerchange", () => {
  // window.location.reload();
});

let width = window.innerWidth;
const enterkeyUpHandler = (e) => { 
  if(e.keyCode=== 13){
    const primaryButtonId = document.getElementById("primaryButtonId");
    const primaryButtonLoaderId = document.getElementById("primaryButtonLoaderId");
    if(primaryButtonId){
      primaryButtonId.click();
    }else if(primaryButtonLoaderId){
      primaryButtonLoaderId.click();
    }
  }
}
if(width > 768){
setTimeout(()=>{
  const el = document.getElementById("root");
  if(el){ 
    el.addEventListener("keyup", enterkeyUpHandler );
  }
},1000);}